<template>
  <div>
    <page-breadcrumb title="Daftar Kamera" :routes="routes" />
    <div v-if="datas.length > 0" class="grid grid-cols-2 gap-4">
      <vx-card
        v-for="(cam, idx) in datas"
        :key="idx"
        :title="cam.camName"
        class="overflow-hidden"
      >
        <div slot="no-body">
          <div class="p-6 text-center">
            <video-player :key="idx" :options="cam.video" />
          </div>
        </div>
      </vx-card>
    </div>

    <vs-popup class="holamundo" title="Select date" :active.sync="popupCalendar">
      <datepicker :inline="true"></datepicker>
      <flat-pickr v-model="pickDate" :config="config" :inline="true"></flat-pickr>
    </vs-popup>
  </div>
</template>

<script>
import VideoPlayer from '../components/VideoPlayer.vue';
import PageBreadcrumb from "../components/PageBreadcrumb.vue";
import Datepicker from 'vuejs-datepicker';
import flatPickr from 'vue-flatpickr-component';
import api from "../api";

import "video.js/dist/video-js.css";
import 'flatpickr/dist/flatpickr.css';

export default {
  data() {
    return {
      pageTitle: "Daftar Kamera",
      popupCalendar: false,
      isLive: true,
      datas: [],
      pickDate: null,
      config: {
        enableTime: true,
      }
    };
  },
  computed: {
    routes() {
      return {
        ...this.$route,
        meta: {
          ...this.$route.meta,
          breadcrumb: [
            { title: "Dashboard", url: "/" },
            { title: "Daftar Kamera", active: true },
          ],
        },
      };
    },
  },
  components: {
    PageBreadcrumb,
    Datepicker,
    flatPickr,
    VideoPlayer
  },
  created() {
    this.$vs.loading();
    this.getCameraView();
  },
  methods: {
    getInstance(art) {
      console.log(art);
    },
    getCameraView() {
      api
        .masterCamera({ Page: 1 })
        .then((result) => result.data.data)
        .then((data) => {
          this.$vs.loading.close();
          this.routes.meta.breadcrumb.push({
            title: this.pageTitle,
            active: true,
          });
          data.map((cam) => {
            const vidData = {
              camName: cam.camName,
              name: cam.name,
              area: cam.area,
              video: {
                autoplay: true,
                controls: true,
                fluid: true,
                liveui: true,
                aspectRatio: "9:16",
                sources: [
                  {
                    src: cam.liveStreamUrl,
                    type: "video/mp4",
                  },
                ],
              },
            };
            this.datas.push(vidData);
          });
        });
    },
  },
};
</script>


<style scoped>
  .camera-container {
    height: 420px;
  }
</style>